/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ParticipantConsentOut {
  participant_id: string;
  user_id: string | null;
  display_name: string | null;
  role: string;
  is_member: boolean;
  has_email: boolean;
  standing_code: string;
  rank_code: string | null;
  source_code: string | null;
  recorded_at: string | null;
  can_act_on_behalf: boolean;
}
